import {
  GET_V3_CONTRIBUTION_AMOUNT_QUERY_KEY,
  V3ContributionAmountResponseDto,
} from '.';
import { useApiQuery } from 'theSource/utils';

export interface UseV3ContributionAmountQueryProps {
  lumosApiHost: string;
  orgBenefitId?: number;
  orgPlanId: number;
  fromMedicalPage?: boolean;
  medicalCoverageLevel?: string;
  medicalOrgPlanId?: number;
  coverageLevelId: number;
  coverageTypeId?: number;
  electionAmount?: number;
  estimatedExpenses?: number;
  contributionAmountType: string;
  hsaContributionEndDate?: Date;
  returnContributionAmountType?: boolean;
  eeLumpSumContributionAmount?: number;
  enrollmentContextType: string;
  factorYtdIntoCalculatedMinMax?: boolean;
  lifeEventCompleted?: boolean;
  resetToInitialCalculatedAmount:boolean;
  initLoad?: boolean;
  resetHsaData?: boolean;
}

export const useV3ContributionAmountQuery = ({
                                             lumosApiHost,
                                             orgBenefitId,
                                             orgPlanId,
                                             fromMedicalPage,
                                             medicalCoverageLevel,
                                             medicalOrgPlanId,
                                             coverageLevelId,
                                             coverageTypeId,
                                             electionAmount,
                                             estimatedExpenses,
                                             contributionAmountType,
                                             hsaContributionEndDate,
                                             returnContributionAmountType,
                                             eeLumpSumContributionAmount,
                                             enrollmentContextType,
                                             factorYtdIntoCalculatedMinMax,
                                             lifeEventCompleted,
                                             resetToInitialCalculatedAmount,
                                             initLoad = false,
}: UseV3ContributionAmountQueryProps, {enabled = false}) => {
  const {
    data: contributionData,
    isLoading: isLoadingContribution,
    isFetching: isFetchingContribution,
    refetch: refetchContribution,
  } = useApiQuery<V3ContributionAmountResponseDto>({
    queryKey:
    GET_V3_CONTRIBUTION_AMOUNT_QUERY_KEY +
      orgPlanId +
      contributionAmountType +
      initLoad,
    config: {
      baseURL: `${lumosApiHost}/v3/self_service`,
    },
    endpoint: '/benefits/contribution',
    params: {
      org_benefit_id: orgBenefitId,
      org_plan_id: orgPlanId,
      from_medical_page: fromMedicalPage,
      medical_coverage_level: medicalCoverageLevel,
      medical_org_plan_id: medicalOrgPlanId,
      coverage_level_id: coverageLevelId,
      coverage_type_id: coverageTypeId,
      election_amount: electionAmount,
      estimated_expenses: estimatedExpenses,
      contribution_amount_type: contributionAmountType,
      hsa_contribution_end_date: hsaContributionEndDate,
      return_contribution_amount_type: returnContributionAmountType,
      ee_lump_sum_contribution_amount: eeLumpSumContributionAmount,
      enrollment_context_type: enrollmentContextType,
      factor_ytd_into_calculated_min_max: factorYtdIntoCalculatedMinMax,
      reset_to_initial_calculated_amount:resetToInitialCalculatedAmount,
      life_event_completed: lifeEventCompleted,
    },
    enabled,
  });

  return {
    contributionData,
    isLoadingContribution,
    isFetchingContribution,
    refetchContribution,
  };
};
